import { render, staticRenderFns } from "./NewGuide.vue?vue&type=template&id=ffc2cdbc&scoped=true&"
import script from "./NewGuide.vue?vue&type=script&lang=js&"
export * from "./NewGuide.vue?vue&type=script&lang=js&"
import style0 from "./NewGuide.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewGuide.vue?vue&type=style&index=1&id=ffc2cdbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc2cdbc",
  null
  
)

export default component.exports